<template>
  <section class="l-section product-block container" :class="{_loading: pendingProduct}">
    <div class="product-block__inner container-inner container-inner--medium">
      <BasePreloader v-if="pendingProduct"/>
      <div class="product-block__main">
        <div class="product-block__img-wrap">
          <img class="product-block__img"
               @click="onImgClick(0)"
               :alt="product.name"
               sizes="(max-width: 1024px) 360px, 600px"
               :src="product.image"
               :srcset="product.image_xs ? `${product.image_xs} 480w, ${product.image_s} 600w` : null">
          <div class="base-label"
               v-if="product.badges && product.badges[0]"
               :style="`background-color:${product.badges[0].color}`"
          >{{ product.badges[0].name }}
          </div>
        </div>
        <div class="product-block__content">
          <div class="product-block__details">
            <h3 class="product-block__title">{{ product.name }}</h3>
            <div class="product-block__subs" v-if="product.description">
              <div class="product-block__subs-inner">
                {{ stripHtml(product.description) }}
              </div>
            </div>
            <div class="product-block__params"
                 v-if="product.variants && product.variants.length > 1
                 || product.properties && product.properties.length > 1">
              <div class="product-block__params-item"
                   v-if="product.variants && product.variants.length > 1">
                <div class="product-block__params-title">
                  {{
                    (settings && settings.pizzaCategoryId == product.category.id) ? $t('Розмір') : $t('Варіант')
                  }}:
                </div>
                <div class="product-block__variants">
                  <div class="product-block__variants-inner">
                    <button v-for="(item, index) in product.variants"
                            :key="index"
                            :class="{_active: selectedVariant === item}"
                            @click.prevent="onSelectVariant(item)"
                            type="button"
                            class="product-block__variants-item base-btn">{{ item.name }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="product-block__params-item"
                   v-if="product.properties && product.properties.length > 1">
                <div class="product-block__params-title">{{ $t('Соус') }}:</div>
                <BaseSelect v-model="propertySelected"
                            :options="product.properties"
                            :error="errors.sauce.error && $t('sauce_required')"
                            textKey="property"
                            class="product-block__select"
                />
              </div>
            </div>
            <div class="product-block__params">
              <div class="product-block__params-item" v-if="mainIngredientsList.length">
                <div class="product-block__params-title">
                  <a href="#mainAdditional"
                     v-scroll-to="'#mainAdditional'"
                     class="product-block__btn-add">
                    <span>
                      <i class="fa fa-plus"></i>
                    </span>
                    {{ $t('Основні інгредієнти') }}
                  </a></div>
                <AdditionalTags :ingredients="mainIngredientsSelected"
                                isMain
                                @delete="deleteMainIngredient"
                                class="product-block__tags"
                />

                <p class="product-block__warning" v-if="errors.mainIngredients.error">{{ $t('main_ingredients_required') }}</p>
              </div>
              <div class="product-block__params-item" v-if="additionalIngredientsList.length">
                <div class="product-block__params-title">
                  <a href="#additional"
                     v-scroll-to="'#additional'"
                     class="product-block__btn-add">
                    <span>
                      <i class="fa fa-plus"></i>
                    </span>
                    {{ $t('Додаткові інгредієнти') }}
                  </a></div>
                <AdditionalTags :ingredients="ingredientsSelected"
                                @delete="deleteIngredient"
                                class="product-block__tags"
                />
              </div>
            </div>
            <div class="product-block__weight" v-if="product.weight">
              <b>{{ $t('Вага') }}:</b>
              {{ product.weight }}
            </div>
            <div class="product-block__price-row">
              <div class="product-block__price price">
                <b>{{ $t('Всього') }}:</b>
                <span class="price__val">{{ fullPrice | formatPrice }}
                  {{ $t('грн') }}</span>
              </div>
            </div>
            <div class="product-block__row-buy">
              <Quantity class="product-block__quantity"
                        v-model="quantity"
              />
              <button type="button"
                      class="product-block__btn-buy base-btn _black"
                      @click="addToBasket"
                      :title="`${$t('Замовити')} ${product.name}`"
              >{{ $t('В кошик') }}
              </button>
            </div>
            <transition name="fade" mode="out-in">
              <a href="#"
                 v-if="!showComment"
                 class="product-block__comment-add"
                 @click.prevent="onAddComment"
              >
                <i class="fa fa-comment"></i>
                {{ $t('Додати коментар') }}
              </a>

              <div v-else
                   class="product-block__comment"
              >
                <button type="button"
                        class="product-block__comment-remove base-btn _black"
                        @click.prevent="onRemoveComment"
                ><i class="fa fa-close"></i></button>
                <BaseInput textarea rows="3" v-model.trim="comment"
                           :placeholder="$t('Ваш коментар')"/>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <Additional id="mainAdditional"
                  v-if="mainIngredientsList.length"
                  @changeIngredient="changeMainIngredient"
                  v-bind="mainIngredientsOptions"
                  class="product-block__additional"
                  isMain
      />
      <Additional id="additional"
                  v-if="additionalIngredientsList.length"
                  @changeIngredient="changeIngredient"
                  v-bind="ingredientsOptions"
                  class="product-block__additional"
      />
    </div>
    <LightBox v-if="product.image"
              :items="[product.image]"
              :index="indexImg"
              @close="onImgClick(null)"
    />
    <AddToBasket :quantity="quantity" ref="add-el"/>
  </section>
</template>

<script>
import LightBox from '@/components/LightBox'
import Quantity from '@/components/Quantity'
import AdditionalTags from '@/components/AdditionalTags'
import Additional from './Additional'
//import {http} from '@/axios'
import stripHtml from '@/helpers/stripHtml'
import {addToBasketAnimation} from '@/helpers/addToBasketAnimation'
import AddToBasket from '@/components/AddToBasket'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'ProductBlockConstructor',
  props: {
    product: Object,
    pendingProduct: Boolean
  },
  components: {
    AddToBasket,
    Additional,
    AdditionalTags,
    Quantity,
    LightBox
  },
  data() {
    return {
      stripHtml,
      indexImg: null,
      quantity: 1,
      showComment: false,
      comment: null,
      propertySelected: null,
      selectedVariant: null,
      ingredientsSelected: {},
      mainIngredientsSelected: {},
      errors: {
        sauce: {
          error: null
        },
        mainIngredients: {
          error: null
        }
      }
    }
  },
  computed: {
    ...mapState({
      maxIngredientsQuantity(state) {
        return state.settings.settings && state.settings.settings.maxCountAdditionalIngredients || 5
      },
      maxMainIngredientsQuantity(state) {
        return state.settings.settings && state.settings.settings.maxCountMainIngredients || 5
      }
    }),
    ...mapState('settings', ['settings']),
    allIngredientsList() {
      return this.product.category && this.product.category.ingredients || []
    },
    mainIngredientsList() {
      return this.allIngredientsList.filter(item => item.show_in_constructor_main) || []
    },
    additionalIngredientsList() {
      return this.allIngredientsList.filter(item => item.show_in_constructor_additional) || []
    },
    mainIngredientsOptions() {
      let options = {
        ingredients: this.mainIngredientsList,
        ingredientsSelected: this.mainIngredientsSelected
      }
      if (this.maxMainIngredientsQuantity) {
        options.maxQuantity = Number(this.maxMainIngredientsQuantity)
      }
      return options
    },
    ingredientsOptions() {
      let options = {
        ingredients: this.additionalIngredientsList,
        ingredientsSelected: this.ingredientsSelected
      }
      if (this.maxIngredientsQuantity) {
        options.maxQuantity = Number(this.maxIngredientsQuantity)
      }
      return options
    },
    variantPrice() {
      return this.selectedVariant && this.selectedVariant.price || 0
    },
    ingredientsPrice() {
      let price = 0

      for (const key in this.ingredientsSelected) {
        const ingredient = this.ingredientsSelected[key]
        price += ingredient.ingredient.price * ingredient.quantity
      }

      return price
    },
    fullPrice() {
      return (this.variantPrice + this.ingredientsPrice) * this.quantity
    }
  },
  methods: {
    ...mapActions('basket', ['addProductToBasket']),
    onImgClick(index) {
      this.indexImg = index
    },
    onSelectVariant(variant) {
      this.selectedVariant = variant
    },
    setDefault() {

      // if (this.product.properties && this.product.properties.length) {
      //   this.propertySelected = this.product.properties[0]
      // }
      if (this.product.variants && this.product.variants.length) {
        this.onSelectVariant(this.product.variants[0])
      }
    },
    onAddComment() {
      this.showComment = true
    },
    onRemoveComment() {
      this.showComment = false
    },
    changeIngredient({ingredient, quantity}) {
      if (!quantity) {
        return this.$delete(this.ingredientsSelected, ingredient.id)
      }

      this.$set(this.ingredientsSelected, ingredient.id, {
        ingredient,
        quantity
      })
    },
    deleteIngredient({ingredient}) {
      this.changeIngredient({ingredient, quantity: 0})
    },
    changeMainIngredient({ingredient, quantity}) {
      if (!quantity) {
        return this.$delete(this.mainIngredientsSelected, ingredient.id)
      }

      this.$set(this.mainIngredientsSelected, ingredient.id, {
        ingredient,
        quantity
      })
    },
    deleteMainIngredient({ingredient}) {
      this.changeMainIngredient({ingredient, quantity: 0})
    },
    addToBasket(event) {
      this.errors.sauce.error = false
      this.errors.mainIngredients.error = false

      if (!this.propertySelected || !Object.keys(this.mainIngredientsSelected).length) {

        if (!this.propertySelected) {
          this.errors.sauce.error = true

        }
        if (!Object.keys(this.mainIngredientsSelected).length) {
          this.errors.mainIngredients.error = true
        }
        return
      }

      const cardObj = {
        type: this.product.type,
        product: this.product,
        quantity: this.quantity,
        variant: this.selectedVariant || null,
        property: this.propertySelected || null,
        main_ingredients: Object.keys(this.mainIngredientsSelected).length ? this.mainIngredientsSelected : null,
        additional_ingredients: Object.keys(this.ingredientsSelected).length ? this.ingredientsSelected : null,
        comment: null,
      }

      if (this.showComment) {
        cardObj.comment = this.comment || null
      }

      addToBasketAnimation(event, this.$refs['add-el'].$el, () => {
        this.addProductToBasket(cardObj)
      })

    }
  }
}
</script>

<style>

</style>
